module.exports = __webpack_public_path__ + "img/unmerge.3ebed2f0.svg";